<form [formGroup]="userContactForm">
    <div class="p-grid">
        <div class="p-col-12">
            <div class="p-field">
                <small>Company Name *</small>
                <input type="text" pInputText class="width-100" formControlName="companyName">
            </div>
        </div>
        <div class="p-col-12">
            <div class="p-field">
                <small>Email Id *</small>
                <input type="text" pInputText class="width-100" formControlName="emailId">
            </div>
        </div>
        <div class="p-col-12">
            <div class="p-field">
                <small>Phone Number</small>
                <input type="number" pInputText class="width-100" formControlName="phoneNumber">
            </div>
        </div>
        <div class="p-col-12">
            <div class="p-field">
                <small>Fax Number</small>
                <input type="number" pInputText class="width-100" formControlName="faxNumber">
            </div>
        </div>
        <div class="p-col-12">
            <div class="p-field">
                <small>Address *</small>
                <input type="text" pInputText class="width-100" formControlName="address">
            </div>
        </div>
        <div class="p-col-12">
            <div class="p-field">
                <small>City</small>
                <input type="text" pInputText class="width-100" formControlName="city">
            </div>
        </div>
        <div class="p-col-12">
            <div class="p-field">
                <small>State</small>
                <input type="text" pInputText class="width-100" formControlName="state">
            </div>
        </div>

        <div class="p-col-12">
            <div class="p-field">
                <small>Country*</small>
                <p-dropdown filter="true" filterBy="countryName" appendTo="body" placeholder="Select.."
                            optionValue="countryCode" [options]="countries"
                            optionLabel="countryName" styleClass="width-100" formControlName="country"></p-dropdown>
            </div>
        </div>

        <div class="p-col-12">
            <div class="p-field">
                <small>Zip Code</small>
                <input type="number" pInputText class="width-100" formControlName="zipCode">
            </div>
        </div>
    </div>
</form>
